(() => {
  const SELECTOR = '[data-lim-section]';

  class LuxuryIconsMuseum {
    constructor(root) {
      this.root = root;
      this.rail = root.querySelector('[data-lim-rail]');
      this.pieces = [...root.querySelectorAll('[data-lim-piece]')];
      this.nav = root.querySelector('[data-lim-nav]');
      this.dotsWrap = root.querySelector('[data-lim-dots]');
      this.current = root.querySelector('[data-lim-current]');
      this.total = root.querySelector('[data-lim-total]');
      this.active = 0;
      this.raf = null;

      if (!this.rail || this.pieces.length < 2 || !this.nav || !this.dotsWrap) return;
      this.init();
    }

    init() {
      this.total.textContent = String(this.pieces.length).padStart(2, '0');
      this.dotsWrap.innerHTML = '';

      this.dots = this.pieces.map((piece, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'lim__dot';
        button.setAttribute(
          'aria-label',
          (this.root.dataset.iconLabel || 'Show icon [index]').replace('[index]', index + 1)
        );
        button.addEventListener('click', () => {
          this.scrollToPiece(piece);
        });
        this.dotsWrap.appendChild(button);
        return button;
      });

      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.rail.addEventListener('scroll', () => this.onScroll(), { passive: true });
      window.addEventListener('resize', () => this.refresh());
      this.refresh();
    }

    scrollToPiece(piece) {
      const railRect = this.rail.getBoundingClientRect();
      const pieceRect = piece.getBoundingClientRect();
      const styles = getComputedStyle(this.rail);
      const rtl = styles.direction === 'rtl';
      const scrollPadding = Number.parseFloat(styles.scrollPaddingInlineStart) || 0;
      const anchor = rtl ? railRect.right - scrollPadding : railRect.left + scrollPadding;
      const delta = rtl ? pieceRect.right - anchor : pieceRect.left - anchor;

      this.rail.scrollBy({
        left: delta,
        behavior: this.reduceMotion ? 'auto' : 'smooth'
      });
    }

    refresh() {
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      this.nav.hidden = !mobile;
      if (mobile) this.updateActive();
    }

    onScroll() {
      if (this.raf) return;
      this.raf = requestAnimationFrame(() => {
        this.updateActive();
        this.raf = null;
      });
    }

    updateActive() {
      const railRect = this.rail.getBoundingClientRect();
      const rtl = getComputedStyle(this.rail).direction === 'rtl';
      const inset = Math.min(railRect.width * 0.24, 110);
      const anchor = rtl ? railRect.right - inset : railRect.left + inset;
      let bestIndex = 0;
      let bestDistance = Infinity;

      this.pieces.forEach((piece, index) => {
        const rect = piece.getBoundingClientRect();
        const edge = rtl ? rect.right : rect.left;
        const distance = Math.abs(edge - anchor);
        if (distance < bestDistance) {
          bestDistance = distance;
          bestIndex = index;
        }
      });

      if (this.active === bestIndex && this.dots?.length) {
        this.paint();
        return;
      }

      this.active = bestIndex;
      this.paint();
    }

    paint() {
      if (this.current) this.current.textContent = String(this.active + 1).padStart(2, '0');
      this.dots?.forEach((dot, index) => dot.classList.toggle('is-active', index === this.active));
    }
  }

  const boot = (scope = document) => {
    scope.querySelectorAll(SELECTOR).forEach((root) => {
      if (root.dataset.limReady === 'true') return;
      root.dataset.limReady = 'true';
      new LuxuryIconsMuseum(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
